<template>
  <div class="navigation" :class="getSidebarIsOpen ? 'is-open' : ''">
    <v-card class="navigation-box">
      <div class="img-container" v-if="getSidebarIsOpen">
        <img src="/images/easy-ticket-logo.svg" />
      </div>
      <v-list class="list" density="compact" nav>
        <div v-for="item in menuItems" :key="item.value">
          <v-list-item
            v-if="item.role.includes(userRole)"
            :prepend-icon="item.icon"
            :title="item.title"
            :value="item.value"
            @click="itemClicked(item.path)"
            :active="currentRoute == item.path"
            :class="!getSidebarIsOpen ? 'closed' : ''"
          />
        </div>
        <v-list-item
          prepend-icon="mdi-logout"
          :title="$t('header.logout')"
          @click="logout"
          class="logout-button"
        />
        <div class="version_number">
          {{ $t("sideBar.version") }} {{ versionNumber }}
        </div>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SideBar",
  data() {
    return {
      versionNumber: process.env.VUE_APP_VERSION_NUMBER,
      menuItems: [
        {
          title: this.$t("sideBar.dashboard"),
          value: 0,
          icon: "mdi-home",
          path: "/",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.users"),
          value: 1,
          icon: "mdi-shield-account",
          path: "/users",
          role: [0],
        },
        {
          title: this.$t("sideBar.partners"),
          value: 2,
          icon: "mdi-account-tie",
          path: "/partners",
          role: [0],
        },
        {
          title: this.$t("sideBar.conductor"),
          value: 3,
          icon: "mdi-ticket-account",
          path: "/validation-users",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.orders"),
          value: 4,
          icon: "mdi-cart",
          path: "/orders",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.anomaly"),
          value: 5,
          icon: "mdi-notebook",
          path: "/anomaly-log",
          role: [0],
        },
        {
          title: this.$t("sideBar.layoutSettings"),
          value: 6,
          icon: "mdi-table-edit",
          path: "/konva-editor",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.capacity"),
          value: 7,
          icon: "mdi-human-capacity-increase",
          path: "/capacity",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.ticketBuyerTypes"),
          value: 8,
          icon: "mdi-ticket-account",
          path: "/types",
          role: [1],
        },
        {
          title: this.$t("sideBar.usageArchive"),
          value: 9,
          icon: "mdi-chart-line",
          path: "/usage-archive",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.salesStatistics"),
          value: 10,
          icon: "mdi-point-of-sale",
          path: "/sales-statistics",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.usedTickets"),
          value: 11,
          icon: "mdi-ticket-confirmation-outline",
          path: "/used-tickets",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.systemSettings"),
          value: 12,
          icon: "mdi-wrench",
          path: "/system-settings",
          role: [0],
        },
        {
          title: this.$t("sideBar.ticketBuyers"),
          value: 13,
          icon: "mdi-ticket-outline",
          path: "/ticket-buyers",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.lockedItems"),
          value: 14,
          icon: "mdi-lock",
          path: "/locked-items",
          role: [0],
        },
        {
          title: this.$t("sideBar.products"),
          value: 15,
          icon: "mdi-ticket-confirmation",
          path: "/products",
          role: [0, 1],
        },
        {
          title: this.$t("sideBar.productGroups"),
          value: 16,
          icon: "mdi-ungroup",
          path: "/product-group",
          role: [0, 1],
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      toggleSideBarStore: "siteSettings/toggleSidebar",
      logoutUser: "users/logoutUser",
    }),
    itemClicked(path) {
      this.$router.push(path);
      if (window.innerWidth <= 1264) {
        this.toggleSideBarStore();
      }
    },
    logout() {
      this.logoutUser();
      location.reload();
    },
  },
  computed: {
    ...mapGetters({
      getSidebarIsOpen: "siteSettings/sidebarIsOpen",
      loggedInUser: "users/loggedInUser",
    }),
    currentRoute() {
      return this.$route.path;
    },
    userRole() {
      return this.loggedInUser && this.loggedInUser.role;
    },
  },
};
</script>

<style lang="scss">
.img-container {
  height: fit-content;
  img {
    height: 64px;
  }
}
.list {
  position: relative;
  .version_number {
    text-align: center;
    padding: 10px 0;

    font-size: 0.8125rem;
    font-weight: 400;
    letter-spacing: normal;
    line-height: 1rem;
    color: #000000de;
  }
}

@media (max-height: 780px) {
  .list {
    position: absolute;
    .version_number {
      position: initial;
      margin-top: 10px;
    }
  }
}
</style>
